// packages/shared-components/src/components/Radio/RadioGroup.tsx

import { RadioGroupProps } from "./types";
import { Radio } from "./Radio";
import styles from "./Radio.module.css";

export function RadioGroup({
  options,
  value,
  onChange,
  direction = "horizontal",
  className = "",
  size = "default",
}: RadioGroupProps) {
  return (
    <div
      className={`${styles.radioGroup} ${
        direction === "vertical" ? styles.vertical : styles.horizontal
      } ${className}`}
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          disabled={option.disabled}
          onChange={onChange}
          size={size}
        />
      ))}
    </div>
  );
}
